<style scoped>

</style>

<template>
  <div
    id="section_timeline"
    class="section-timeline"
    style="position: relative; cursor: pointer;"
    @click="onSectionTimelineClick"
  >
    <TemplateSectionEditToggle :moduleOrSection="section"/>
    <div class="SectionTable">
      <TemplateSectionRow
        v-for="(row, i) in rowsHeader"
        :key="i"
        :row="row"
      />
      <TemplateSectionRow emptyRow/>
    </div>

    <div>
      <div class="SectionTable">
        <TemplateSectionRow
          v-for="(row, i) in rows"
          :key="i"
          :row="row"
        />
        <TemplateSectionRow emptyRow/>
      </div>
    </div>
  </div>
</template>

<script>
import TemplateSectionRow
  from '@/components/sections/TemplateSection/TemplateSectionResourceTableRow';
import Mixin from '@/mixins/mixin';
import TemplateSectionEditToggle from '@/components/sections/TemplateSectionEditToggle';

export default {
  name: 'TemplateSectionTimeline',
  components: {
    TemplateSectionEditToggle,
    TemplateSectionRow,
  },
  mixins: [Mixin],
  props: {
    isScrolled: Boolean,
    section: Object,
  },
  data() {
    return {
      drawer: null,
      showDatePicker: false,
    };
  },
  computed: {
    rowsHeader() {
      const rows = [];
      const units = this.translate('ui_assumptions_columns__units');
      rows.push({}, {}, {
        className: 'row-subsection-header',
        content: this.section.title,
        units,
        zeroPeriod: '"0"',
      });
      return rows;
    },
    rows() {
      const rows = [];
      const payload = this.$store.state.activeTemplate;
      const firstDateText = payload.data.options.timing.dateStart;
      const firstDateObj = new Date(firstDateText);
      // eslint-disable-next-line
      let firstDateValue = new Date(firstDateObj.getFullYear(), firstDateObj.getMonth(), firstDateObj.getDate() + 1);
      firstDateValue = this.localizeDate(firstDateValue);

      rows.push({ className: 'row-input', content: 'ui_assumptions_forecast_start', fcst: [firstDateValue] });
      const periodicity = this.translate(payload.data.options.timing.periodicity);
      rows.push({ className: 'row-input', content: 'ui_assumptions_period_type', fcst: [periodicity] });

      // eslint-disable-next-line
      rows.push({ id: 'periodStart', content: 'ui_assumptions_period_start' });
      rows.push({ id: 'periodEnd', content: 'ui_assumptions_period_end' });
      rows.push({ id: 'daysInPeriod', content: 'ui_assumptions_days_period' });
      // rows.push({ content: 'assumptions_period_label' });

      return rows;
    },
  },
  methods: {
    onSectionTimelineClick() {
      const isTemplatePaidFor = !this.$store.state.activeTemplate.price;
      if (isTemplatePaidFor) {
        this.$store.state.activeTemplate.isNavigatorVisible = 'section_timeline';
      }
    },
  },
  mounted() {
    // if no wizard, display timeline
    if (!this.$store.state.activeTemplate.isWizardEnabled) {
      this.$store.dispatch('updateState', {
        path: 'activeTemplate.data.sections[1].isVisible',
        value: true,
      });
    }
  },
};
</script>
